import React from 'react';
import Container from '@material-ui/core/Container';
import UiCore from '../Components/UiCore';
import MFAUserSettings from '../Components/MFA/MFAUserSettings';

const AccountSecurity = (props) => {
  return (
    <UiCore
      title="Account Security"
      content={
        <Container maxWidth="md" style={{ paddingTop: 24 }}>
          <MFAUserSettings />
        </Container>
      }
    />
  );
};

export default AccountSecurity;
